import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import { CardActionArea } from '@prisjakt/ui/card';
import Clickable from '@prisjakt/ui-clickable';

import { BaseProps } from '../../types';

import { ActionButton, Card } from './styles';

type Props = Pick<
  BaseProps,
  | 'link'
  | 'className'
  | 'container'
  | 'background'
  | 'selected'
  | 'selectable'
  | 'onClick'
  | 'onDeselect'
  | 'onSelect'
  | 'buttonAriaLabel'
  | 'ActionArea'
  | 'FooterArea'
  | 'isClickable'
>;

export const GridCard: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<Props>
>> = props => {
  const { renderMode } = useContext(AppContext);

  const {
    buttonAriaLabel,
    background,
    children,
    className,
    link,
    onClick,
    onDeselect = () => {},
    onSelect = () => {},
    selectable,
    selected,
    ActionArea = null,
    FooterArea = null,
    isClickable = true,
  } = props;

  const handleSelect = () => {
    if (selected) {
      onDeselect();
    } else {
      onSelect();
    }
  };

  return (
    <Card
      className={className}
      background={background}
      outlined
      selected={selected}
      container={'article' as any}
      containerProps={{ 'data-test': 'ProductGridCard' }}
    >
      {ActionArea && <ActionButton>{ActionArea}</ActionButton>}

      {isClickable ? (
        <CardActionArea
          container={Clickable}
          containerProps={{
            to: selectable ? undefined : link,
            'aria-label': buttonAriaLabel,
            isExternal: renderMode === 'native',
            onClick: selectable ? handleSelect : onClick,
            style: { flex: '1 1 auto', cursor: 'pointer' },
          }}
        >
          {children}
        </CardActionArea>
      ) : (
        children
      )}

      {FooterArea}
    </Card>
  );
};
